/**
 * A API Issuer autentica via JWT (Bearer). Headers de contexto tenant/app
 * não são necessários — o token já carrega as claims de autorização.
 */
export const issuerProviders = [] as const;

export const issuerInterceptors = [] as const;
